// export const baseURL = "http://localhost:4448/web/api/"; // URL for local
export const baseURL = "https://email.countermachine.in/UnlimitedMail/"; // URL for staging
// export const baseURL = "https://apiloyalty.novusloyalty.com/web/api/"; // URL for Live
export const cardUrl = "https://buy.stripe.com/8wM4gC7oh0bJ7qodQR";
